// src/components/Navbar.js

import axios from "../utils/axiosConfig";
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

import KPMGLogo from "../Images/optimized/KPMG_Private_Enterprise_logo-white_9259.png";
import "../Style/Navbar.css";
import "../Style/Responsive.css";
import { useLanguage } from "../contexts/LanguageContext";

function Navbar() {
  const location = useLocation();
  const token = localStorage.getItem("token");
  const userType = localStorage.getItem("user_type");

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isHomePage = location.pathname === "/";

  const { language, toggleLanguage, t } = useLanguage();

  const toggleMenu = () => setIsMenuOpen((s) => !s);

  const handleLogout = async () => {
    try {
      await axios.post("/logout/", null, {
        headers: { "X-Skip-Auth-Redirect": "1" },
      });
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      localStorage.removeItem("token");
      localStorage.removeItem("user_type");
      localStorage.removeItem("current_user");
      localStorage.setItem("logout_at", String(Date.now()));
      try {
        delete axios.defaults.headers.common.Authorization;
      } catch {}
      setIsMenuOpen(false);
      window.location.assign("/");
    }
  };

  return (
    <nav className="navbar">
      <div className="logo">
        <Link
          to="/"
          onClick={() => setIsMenuOpen(false)}
          style={{ textDecoration: "none", display: "flex", alignItems: "center" }}
        >
          <img src={KPMGLogo} alt="KPMG Logo" className="logo-img" />
          <h2 id="logoword">Africa Centre of Excellence</h2>
        </Link>
      </div>

      <button
        className={`nav-toggle ${isMenuOpen ? "active" : ""}`}
        onClick={toggleMenu}
        aria-label="Toggle navigation"
      >
        <span className="bar" />
        <span className="bar" />
        <span className="bar" />
      </button>

      <ul className={`nav-links ${isMenuOpen ? "active" : ""}`}>
        <li>
          <Link to="/" onClick={toggleMenu}>{t('nav_home')}</Link>
        </li>

        {token ? (
          <>
            {isHomePage && (
              <li>
                <Link to="/contact" target="_blank" rel="noopener noreferrer" onClick={toggleMenu}>
                  {t('nav_contact')}
                </Link>
              </li>
            )}
            {userType === "investee" && (
              <li>
                <Link to="/investee-match" onClick={toggleMenu}>
                  Get Matched
                </Link>
              </li>
            )}
            <li>
              <Link to={userType === "investor" ? "/investor-page" : "/investee-page"} onClick={toggleMenu}>
                {t('nav_dashboard')}
              </Link>
            </li>
            <li>
              <Link to="/insights" onClick={toggleMenu}>{t('nav_insights')}</Link>
            </li>
            <li>
              <button onClick={handleLogout} className="btn-logout">{t('nav_logout')}</button>
            </li>
          </>
        ) : (
          <>
            <li>
              <Link to="/about" onClick={toggleMenu}>{t('nav_about')}</Link>
            </li>
            <li>
              <Link to="/programs" onClick={toggleMenu}>{t('nav_programs')}</Link>
            </li>
            <li>
              <Link to="/insights" onClick={toggleMenu}>{t('nav_insights')}</Link>
            </li>
            <li>
              <Link to="/contact" target="_blank" rel="noopener noreferrer" onClick={toggleMenu}>
                {t('nav_contact')}
              </Link>
            </li>
            <li>
              <Link to="/login" onClick={toggleMenu}>{t('nav_login')}</Link>
            </li>
            <li>
              <Link to="/register" className="btn-primary" onClick={toggleMenu}>
                Join Now
              </Link>
            </li>
          </>
        )}

        {/* Language toggle */}
        <li className="nav-toggles">
          <button
            className="nav-icon-btn lang-toggle"
            onClick={toggleLanguage}
            aria-label="Toggle language"
            title={language === 'en' ? 'Switch to French' : 'Switch to English'}
          >
            {language === 'en' ? 'FR' : 'EN'}
          </button>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
